<template>
  <div>
    <template>
      <div>
        <beautiful-chat
          v-if="ischatwindow"
          :participants="participants"
          :titleImageUrl="titleImageUrl"
          :onMessageWasSent="onMessageWasSent"
          :messageList="messageList"
          :newMessagesCount="newMessagesCount"
          :isOpen="isChatOpen"
          :close="closeChat"
          :open="openChat"
          :showEmoji="false"
          :showFile="true"
          :showEdition="true"
          :showDeletion="true"
          :showTypingIndicator="showTypingIndicator"
          :showLauncher="true"
          :showCloseButton="true"
          :alwaysScrollToBottom="alwaysScrollToBottom"
          :disableUserListToggle="false"
          :messageStyling="messageStyling"
          @onType="handleOnType"
          @edit="editMessage"
        >
          <template v-slot:text-message-body="{ message }">
            <small style="background: red" v-if="message.meta">
              {{ message.meta }}
            </small>
            <chat-message></chat-message>
            <span v-autolinker="message.data.text"></span>
          </template>
        </beautiful-chat>
      </div>
    </template>

    <beautiful-chat
      class="popupModal"
      v-if="!ischatwindow"
      :participants="[]"
      :messageList="[]"
      :newMessagesCount="0"
      :isOpen="false"
      :showCloseButton="true"
      :alwaysScrollToBottom="false"
      :open="openModal"
      :close="() => {}"
      :onMessageWasSent="() => {}"
      :onUserInputSubmit="() => {}"
      :onSubmit="() => {}"
    />
    <div class="preview-doc">
      <div class="preview">
        <vs-popup title="Preview" class="confirmPopup" :active.sync="preview">
          <div v-if="previewLinks[image]" class="w-full p-5 text-center">
            <img
              v-if="!image.includes('.pdf')"
              :src="previewLinks[image]"
              class="img-responsive"
              height="200"
            />
            <iframe
              v-else
              class="w-100 custom-image-class"
              :src="previewLinks[image]"
              height="200"
              style="border: none"
            />
          </div>
          <div v-else class="w-full p-5 text-center">
            <DropFileForm @selectedFile="selectedFile" />
          </div>

          <div class="w-full text-center">
            <b-button size="md" @click="selectedImage1" variant="primary">
              {{ $t("Select") }}
            </b-button>
          </div>
        </vs-popup>
      </div>
    </div>
    <b-modal
      hide-footer
      ref="live-chat-kickstart-form"
      scrollable
      title="Live Chat"
    >
      <b-overlay
        :show="isScheduling"
        variant="light"
        :opacity="0.85"
        blur="2px"
        rounded="lg"
        spinner-variant="primary"
      >
        <div class="live-chat" v-if="!showForm">
          <div class="department-list mt-2 ml-5 mr-5 mb-10">
            <div class="department-header">
              <div :style="buttonCss" class="marker"></div>
              <div class="department-name">
                <span class="custome-text-color">{{
                  this.department.department_name
                }}</span>
              </div>
              <div class="arrow"></div>
            </div>
            <div
              class="mt-10 department-desc ql-editor custome-text-color"
              v-html="this.department.description"
            ></div>
            <br />
            <div class="nextArrow">
              <b-button @click="getForm()" :style="buttonCss" variant="primary">
                <i class="feather icon-arrow-right"></i>
              </b-button>
            </div>
          </div>
        </div>
        <div v-if="showForm">
          <h6 :style="textColor">
            {{ $t("EnterDetails") }}
          </h6>
          <form id="schedule" data-vv-scope="schedule">
            <div
              class="vx-row"
              v-for="(field, index) in formFields"
              :key="index"
            >
              <div
                class="vx-col md:w-full w-full mt-4"
                v-if="field.shown && field.type == 'input'"
              >
                <label :style="textColor" class="vs-input--label">{{
                  $t(field.label != undefined ? field.label : $t(index))
                }}</label>
                <b-form-input
                  size="lg"
                  v-validate="{
                    required: field.required,
                    email: index == 'email' ? true : false,
                    max:
                      index == 'age'
                        ? 2
                        : index == 'first_name' || index == 'last_name'
                        ? 20
                        : false,
                    min_value: index == 'age' ? 1 : false,
                  }"
                  :name="field.label != undefined ? field.label : index"
                  :data-vv-as="
                    $t(field.label != undefined ? field.label : index)
                  "
                  :placeholder="
                    field.label != undefined ? field.label : $t(index)
                  "
                  v-model="scheduleEvent[index]"
                  class="w-full"
                  :disabled="
                    index == 'email'
                      ? scheduleEvent['id']
                        ? true
                        : false
                      : false
                  "
                  :type="index == 'age' ? 'number' : 'text'"
                ></b-form-input>
                <span
                  class="text-danger text-sm"
                  v-show="
                    errors.has(
                      'schedule.' +
                        (field.label != undefined ? field.label : index)
                    )
                  "
                  >{{
                    errors.first(
                      "schedule." +
                        (field.label != undefined ? field.label : index)
                    )
                  }}</span
                >
              </div>
              <div
                :style="textColor"
                class="vx-col md:w-full w-full mt-8"
                v-if="field.shown && field.type == 'contact'"
              >
                <label :style="textColor" class="contact_number_label">{{
                  $t(index)
                }}</label>
                <vue-tel-input
                  size="large"
                  v-validate="{
                    required: field.required,
                    regex: /^(?=.*[0-9])[- +()0-9]+$/,
                    min: 12,
                  }"
                  v-model="scheduleEvent[index]"
                  class="w-full contact_number"
                  v-on:country-changed="countryChanged"
                  v-bind="bindProps"
                  @onInput="onInput"
                  v-on:blur="appendCode"
                  :data-vv-as="$t(index)"
                  :placeholder="$t(index)"
                ></vue-tel-input>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('schedule.' + index)"
                  >{{ errors.first("schedule." + index) }}</span
                >
              </div>
              <div
                class="vx-col md:w-full w-full mt-8"
                v-if="field.shown && field.type == 'select'"
              >
                <label :style="textColor">{{ $t(index) }}</label>
                <v-select
                  class="mt-1 w-full"
                  v-validate="{ required: field.required }"
                  v-model="scheduleEvent[index]"
                  :options="genderArray"
                  :name="field.label != undefined ? field.label : index"
                  :data-vv-as="$t(index)"
                  :placeholder="$t('Select') + $t(index).toLowerCase()"
                >
                  <template v-slot:option="option">
                    <span :style="textColor" :class="option.icon"
                      >{{ option.label }}
                    </span>
                    <feather-icon
                      v-if="
                        scheduleEvent[index] &&
                        scheduleEvent[index] == option.label
                      "
                      icon="CheckIcon"
                      class="float-right"
                      svgClasses="w-5 h-5"
                    />
                  </template>
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('schedule.' + index)"
                  >{{ errors.first("schedule." + index) }}</span
                >
              </div>

              <div
                class="vx-col md:w-full w-full mt-8"
                v-if="field.shown && field.type == 'calender'"
              >
                <label :style="textColor">{{ $t(index) }}</label>

                <b-form-datepicker
                  :placeholder="$t('Select') + $t(index).toLowerCase()"
                  v-model="scheduleEvent[index]"
                  v-validate="{ required: field.required }"
                  :format="format"
                  :disabled-dates="state.disabledDates"
                  :name="'schedule.' + index"
                  :data-vv-as="$t(index)"
                  class="p-1 datepick"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  :show-decade-nav="showDecadeNav"
                  :hide-header="hideHeader"
                ></b-form-datepicker>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('schedule.' + index)"
                  >{{ errors.first("schedule." + index) }}</span
                >
              </div>

              <div
                class="vx-col md:w-1/2 w-full mt-8 identity"
                v-if="field.shown && field.type == 'file'"
              >
                <label :style="textColor">{{ $t(index) }}</label>

                <v-select
                  class="mt-1 w-full"
                  v-validate="{ required: field.required }"
                  v-model="scheduleEvent['type']"
                  :options="documentTypeArray"
                  :name="field.label != undefined ? field.label : index"
                  :data-vv-as="$t(index)"
                  :placeholder="$t('Select') + $t(index).toLowerCase()"
                >
                  <template v-slot:option="option">
                    <span :style="textColor" :class="option.icon"
                      >{{ option.label }}
                    </span>
                    <feather-icon
                      v-if="
                        scheduleEvent['type'] &&
                        scheduleEvent['type'].code == option.code
                      "
                      icon="CheckIcon"
                      class="float-right"
                      svgClasses="w-5 h-5"
                    />
                  </template>
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('schedule.' + index)"
                  >{{ errors.first("schedule." + index) }}</span
                >
              </div>

              <!-- =================== -->
              <div
                class="vx-col md:w-1/2 w-full mt-8"
                v-if="field.shown && field.type == 'file'"
              >
                <label :style="textColor">{{
                  $t("Upload") + " " + $t("document").toLowerCase()
                }}</label>
                <span :style="textColor" v-if="field.required">*</span>
                <div class="clearfix"></div>
                <img :src="url" class="mr-8 rounded mt-1" width="85px" />

                <b-button
                  variant="primary"
                  class="mr-4 mb-4 mt-2 booking-form-btn"
                  size="lg"
                  :style="buttonCss"
                  @click="preview = true"
                  >{{ $t("Upload") }}</b-button
                >
                <br />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('schedule.' + 'uploadDocument')"
                  >{{ errors.first("schedule." + "uploadDocument") }}</span
                >
              </div>

              <!-- ==================== -->
            </div>
            <br />
            <div
              class="vx-row"
              v-for="(field, index) in questionsFields"
              :key="index"
            >
              <div
                class="vx-col md:w-full w-full mt-1"
                v-if="field.shown && field.type == 'input'"
              >
                <label :style="textColor" class="vs-input--label">{{
                  $t(field.label != undefined ? field.label : $t(index))
                }}</label>
                <b-form-input
                  size="lg"
                  v-validate="{
                    required: field.required,
                  }"
                  :name="field.label != undefined ? field.label : index"
                  :data-vv-as="
                    $t(field.label != undefined ? field.label : index)
                  "
                  :placeholder="
                    field.label != undefined ? field.label : $t(index)
                  "
                  v-model="selectedInput[index]"
                  class="w-full"
                  :type="'text'"
                ></b-form-input>
                <span
                  class="text-danger text-sm"
                  v-show="
                    errors.has(
                      'schedule.' +
                        (field.label != undefined ? field.label : index)
                    )
                  "
                  >{{
                    errors.first(
                      "schedule." +
                        (field.label != undefined ? field.label : index)
                    )
                  }}</span
                >
              </div>

              <div
                class="vx-col md:w-full w-full mt-5"
                v-if="field.shown && field.type == 'text-area'"
              >
                <label :style="textColor" class="vs-input--label">{{
                  $t(field.label != undefined ? field.label : $t(index))
                }}</label>
                <b-form-textarea
                  size="lg"
                  v-validate="{
                    required: field.required,
                  }"
                  :name="field.label != undefined ? field.label : index"
                  :data-vv-as="
                    $t(field.label != undefined ? field.label : index)
                  "
                  v-model="selectedInput[index]"
                  class="w-full"
                ></b-form-textarea>
                <span
                  class="text-danger text-sm"
                  v-show="
                    errors.has(
                      'schedule.' +
                        (field.label != undefined ? field.label : index)
                    )
                  "
                  >{{
                    errors.first(
                      "schedule." +
                        (field.label != undefined ? field.label : index)
                    )
                  }}</span
                >
              </div>
              <div
                class="vx-col md:w-full w-full mt-5"
                :style="textColor"
                v-if="field.shown && field.type == 'checkbox'"
              >
                <b-form-group :label="field.label" v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    v-model="selectedInput[index]"
                    :options="field.option_questions"
                    :aria-describedby="ariaDescribedby"
                    :name="'check' + index"
                    @click="checkValidation(selectedInput[index], index)"
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
                <div v-if="checkValidation(selectedInput[index], index)">
                  <span class="text-danger text-sm" v-if="field.required">{{
                    $t("checkboxError")
                  }}</span>
                </div>
                <div :id="'input' + index" class="hide-check">
                  <span class="text-danger text-sm" v-if="field.required">{{
                    $t("checkboxError")
                  }}</span>
                </div>
              </div>

              <div
                class="vx-col md:w-full w-full mt-5"
                v-if="field.shown && field.type == 'radio'"
              >
                <small :style="textColor">{{
                  $t(field.label != undefined ? field.label : $t(index))
                }}</small>

                <div class="mt-2">
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio
                      :key="option"
                      v-for="option in field.option_questions"
                      v-model="selectedInput[index]"
                      :aria-describedby="ariaDescribedby"
                      :name="'option' + field.id"
                      :value="option"
                      >{{ option }}</b-form-radio
                    >
                  </b-form-group>
                </div>

                <div>
                  <span
                    class="text-danger text-sm"
                    v-show="
                      errors.has(
                        'schedule.' +
                          (field.label != undefined ? field.label : index)
                      )
                    "
                    >{{
                      errors.first(
                        "schedule." +
                          (field.label != undefined ? field.label : index)
                      )
                    }}</span
                  >
                </div>
              </div>
              <div
                class="vx-col w-full mt-3"
                v-if="field.shown && field.type == 'files'"
              >
                <h4>
                  {{ $t(field.label != undefined ? field.label : $t(index))
                  }}<span :style="textColor" v-if="field.required">*</span>
                </h4>
                <div
                  v-for="(file, index3) in field.option_questions"
                  :key="index3"
                  class="w-8/12"
                >
                  <label class="w-full mb-1"
                    >{{ file }}
                    <span :style="textColor" v-if="field.required">*</span>
                  </label>

                  <template
                    v-if="
                      selectedInput[index] &&
                      selectedInput[index][file] &&
                      isFile(selectedInput[index][file])
                    "
                  >
                    <span class="w-10/12 text-info">
                      {{ selectedInput[index][file].name }}
                    </span>
                    <a
                      class="w-2/12 text-danger"
                      @click.prevent="unsetFile(index, file)"
                      title="Remove"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="float-right"
                        svgClasses="h-5"
                      />
                    </a>
                  </template>

                  <template v-else>
                    <input
                      :ref="file"
                      type="file"
                      v-validate="{
                        required: field.required,
                        size: 5048,
                      }"
                      class="hidden"
                      :name="`${file}-${index}`"
                      accept="image/*, application/pdf,doc, pdf, xls, jpg, png, ppt"
                      :data-vv-as="$t('documents')"
                      @change="setFiles(index, file, $event)"
                    />
                    <img
                      @click="$set(preview1, index3, true)"
                      :src="defaultImg"
                      class="ml-5 mr-5 rounded mt-1"
                      width="32px"
                    />

                    <b-button
                      variant="primary"
                      class="mr-4 mb-4 mt-2 booking-form-btn"
                      size="md"
                      :style="buttonCss"
                      @click="$set(preview1, index3, true)"
                      >{{ $t("Upload") }}</b-button
                    >
                    <vs-popup
                      :title="`Preview`"
                      class="confirmPopup"
                      :active.sync="preview1[index3]"
                    >
                      <div
                        v-if="previewLinks[image]"
                        class="w-full p-5 text-center"
                      >
                        <img
                          v-if="!image.includes('.pdf')"
                          :src="previewLinks[image]"
                          class="img-responsive"
                          height="200"
                        />
                        <iframe
                          v-else
                          class="w-100 custom-image-class"
                          :src="previewLinks[image]"
                          height="200"
                          style="border: none"
                        />
                      </div>
                      <div v-else class="w-full p-5 text-center">
                        <DropFileForm
                          @selectedFile="setFiles"
                          :idx="index"
                          :labelFile="file"
                        />
                      </div>

                      <div class="w-full text-center">
                        <b-button
                          size="md"
                          @click="selectedImage2(index, file, image, index3)"
                          variant="primary"
                        >
                          {{ $t("Select") }}
                        </b-button>
                      </div>
                    </vs-popup>
                  </template>

                  <br />

                  <span
                    v-if="errors.has(`schedule.${file}-${index}`)"
                    class="text-danger text-sm mb-1"
                  >
                    {{ errors.first(`schedule.${file}-${index}`) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="vx-col">
              <b-button
                variant="primary"
                :style="buttonCss"
                size="lg"
                @click="schedule('schedule')"
                class="mt-5 block"
                >{{
                  this.type == "walkin"
                    ? $t("StartMeeting")
                    : $t("ScheduleEvent")
                }}</b-button
              >
            </div>
          </form>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>
<script>
import constants from "@/utils/constants";
import fileIcon from "@/utils/file-icon";
import moment from "moment";
import $ from "jquery";
import { VueTelInput } from "vue-tel-input";
import "moment-timezone";
import Cookies from "js-cookie";
// For custom error message
import { Validator } from "vee-validate";
import { getStripeKey } from "@/utils/stripe";
import I18n from "@/layouts/components/navbar/components/I18n.vue";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { getErrorMessage, sleep, phoneConfig, debounce } from "@/utils/helper";
import DropFileForm from "../DropFileForm.vue";
import { getIndividualChatMessages, getChatAndContact } from "@/api/chat";
import {
  saveEventChatMessage,
  getAppointmentDetails,
  getDefaultQuestionFields,
} from "@/api/appointment";
export default {
  name: "app",
  props: {
    dataset: Object,
  },
  data() {
    return {
      isScheduling: false,
      arr: [],
      participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: "",
      locale: "en",
      // messageList: [
      //     { type: 'text', author: `me`, data: { text: `Say yes!` } },
      //     { type: 'text', author: `user1`, data: { text: `No.` } }
      // ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false,
      ischatwindow: false,
      isModalOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          // bg: '#4e8cff',
          // text: '#ffffff'
        },
        launcher: {
          // bg: '#4e8cff'
        },
        messageList: {
          // bg: '#ffffff'
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
      scheduleEvent: [],
      questionsFields: [],
      state: {
        disabledDates: {
          // Disable all dates up to specific date
          from: new Date(), // Disable all dates after specific date
        },
      },
      disabledDates: [],
      dateMarked: [],
      selectedInput: {},
      formFields: {},
      isLogin: false,
      showDecadeNav: true,
      hideHeader: true,
      nextMonthStartDate: new Date(),
      slots_availablity: [],
      options: [],
      dateSel: "",
      colorx: "#c72a75",
      type: "normal",
      startMeeting: "",
      is_confirm: true,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      show: false,
      currentSelectedDate: "",
      start_time: "",
      end_time: "",
      genderArray: [
        this.$t("Male"),
        this.$t("Female"),
        this.$t("Prefernottosay"),
      ],
      documentTypeArray: [
        { code: 1, label: this.$t("Passport"), _label: "Passport" },
        { code: 2, label: this.$t("IdentityCard"), _label: "IdentityCard" },
        { code: 3, label: this.$t("DrivingLicense"), _label: "DrivingLicense" },
      ],
      format: "yyyy-MM-dd",
      id: "",
      timeZone: "",
      department: [],
      showForm: false,
      buttonCss: {},
      textColor: {},
      website_url: null,
      selectedInput: {},
      checkFields: [],
      questionsFields: [],
      chatDetails: [],
      userdata: [],
      messages: [],
      replyMsg: null,
      activeUser: "",
      company_id: "",
      meet: false,
      image: [],
      imageObject: [],
      images: "",
      url: require("@/assets/images/portrait/small/default_upload.png"),
      defaultImg: require("@/assets/images/portrait/small/default_upload.png"),
      previewLinks: [],
      preview: false,
      preview1: [],
      bindProps: phoneConfig(this.$t("ContactNumber")),
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  components: {
    VueTelInput,
    I18n,
    "v-select": vSelect,
    Datepicker,
    DropFileForm,
  },
  computed: {
    locale() {
      return this.$i18n.locale || "en";
    },
    activeUserInfo() {
      return this.$store.getters.token;
    },
    header() {
      return this.$store.getters.header;
    },
    messageList() {
      const locale = this.locale;
      let token = this.activeUserInfo.replace(/\./g, ":DOT:");
      const iconUrl = constants.BACKEND_URL + "/";
      return this.messages
        .filter((message) => !message.is_deleted)
        .map((message) => {
          let messageText = message.message ? message.message : null;
          if (
            message &&
            message.translations &&
            message.translations.length > 0
          ) {
            const translated = message.translations.find(
              (t) => t.locale == locale
            );
            messageText = translated
              ? translated.message
              : translated[0].message;
          }
          if (message.is_file === 0 && Boolean(message.file) == false) {
            return {
              type: "text",
              author:
                message.sender_user_role == "staff"
                  ? message.sender_name
                  : "me",
              data: { text: messageText },
            };
          } else {
            let fileUrl = message.file.url + token;
            let icon = fileIcon[message.file.mime];

            if (icon == undefined) {
              if (message.file.mime.includes("audio")) icon = fileIcon["audio"];
              else if (message.file.mime.includes("video"))
                icon = fileIcon["video"];
              else if (message.file.mime.includes("font"))
                icon = fileIcon["font"];
              else if (message.file.mime.includes("image")) icon = null;
              else icon = fileIcon.generic;
            }
            return {
              author:
                message.sender_user_role == "staff"
                  ? message.sender_name
                  : "me",
              type: "file",
              id: 1,
              isEdited: false,
              data: {
                file: {
                  name: message.file.file_name,
                  url: fileUrl,
                  thumbnail_url: icon
                    ? `${constants.BACKEND_URL}/images/icons/${icon}`
                    : fileUrl,
                },
                text: messageText,
              },
            };
          }
        });
    },
  },
  mounted() {
    this.$store.commit("SET_USER_ACTIVE_CHANNEL");
    console.log("dataset", this.dataset);
    $(".sc-launcher").removeAttr("style");
    this.getCustomStyle();
    this.getDepartmentDetails();
    this.getAppointmentDetails();
    this.getTimeZones();

    this.timeZone =
      moment.tz.guess() !== "Asia/Calcutta"
        ? moment.tz.guess()
        : "Asia/Kolkata";
    this.slot = this.$route.params.slot || null;
    if (this.slot && this.slug) {
      this.decode = window.atob(this.slot);
      let [department_id, timeSlot, timeDate, timeZone] =
        this.decode.split("&");
      this.dep_id = department_id;
      this.start_time = timeSlot;
      this.start_date = timeDate;
      this.timeZone = timeZone;
      // this.selectDpt(this.dep_id);

      this.selectTime.date = this.start_date;
      this.dateSel = this.selectTime;
      // this.getTimeSlots(this.dateSel);

      let time = moment(this.start_time, "hhmmss").format("hh:mm A");
      this.start_time = time;
    }
  },
  methods: {
    checkValidation(arr, index) {
      if (arr == undefined) return false;
      if (arr.length) $("#input" + index).addClass("hide-check");
      if (arr == undefined || arr == "") {
        return true;
      }
      return false;
    },
    checkValidationRadio(arr, check) {
      if (check == 0 && !arr) {
        return false;
      }
      if (arr == undefined || arr == "") {
        return true;
      }
    },
    selectedImage1() {
      this.setUploadImage();
    },
    setUploadImage() {
      console.log("imageObject", this.imageObject);
      if (this.imageObject.type == "application/pdf")
        this.url = require("@/assets/images/portrait/small/default_pdf.png");
      else this.url = URL.createObjectURL(this.imageObject);
      this.preview = false;
      this.imagesObject = [];
    },
    showImage(idx) {
      console.log(this.arr);
      let label = this.arr[0];
      this.arr = [];
      console.log("test", this.selectedInput);
      let check = this.selectedInput[idx];
      if (!check) this.$set(this.selectedInput, idx, {});
      this.$set(this.selectedInput[idx], label, this.imageObject);
      console.log(this.imageObject);
      console.log(idx, "--", label);
      console.log("this.selectedInput[idx]", this.selectedInput[idx]);
    },
    async selectedImage2(idx, label, name, fileIndex = null) {
      this.$set(this.preview1, fileIndex, false);
      let index = this.indexFile.split("-")[1];
      this.indexFile = "";
      this.showImage(index);
    },
    isFile(file) {
      return file instanceof File;
    },
    unsetFile(idx, label) {
      if (this.selectedInput[idx][label]) {
        this.$set(this.selectedInput[idx], label, null);
      }
      this.image = "";
      this.imageObject = "";
      if (this.$refs[label] && this.$refs[label][0])
        this.$refs[label][0].value = "";
    },
    setFiles(idx, label, file, from = "") {
      console.log("setFiles...", idx, label, file);
      if (from == "") {
        console.log("FormEmpty...");
        if (!this.selectedInput[idx]) this.$set(this.selectedInput, idx, {});

        const selectedFiles = file;

        if (selectedFiles.length < 1) return;
        console.log(label, selectedFiles);
        this.$set(this.selectedInput[idx], label, selectedFiles);
        this.image = file;
        console.log("image", this.image);

        let id = `${label}-${idx}`;
        const firstPart = id.split("-")[0];
        this.arr.push(firstPart);
      } else {
        console.log("FormNotEmpty...");
        this.imageObject = file;
        this.image = file;
        this.indexFile = `${label}-${idx}`;
        let fileName = `${label}-${idx}`;
        console.log("FormNotEmpty...", this.indexFile);
        const firstPart = fileName.split("-")[0];
        this.arr.push(firstPart);
      }
    },
    selectedFile(file) {
      this.images = file;
      if (this.images.type == "application/pdf")
        this.url = require("@/assets/images/portrait/small/default_pdf.png");
      else this.url = URL.createObjectURL(this.images);
      this.imageObject = file;
    },
    getFields(id) {
      this.error = "";
      this.$store
        .dispatch("GetFields", id)
        .then((res) => {
          if (res.data.data.form_fields) {
            this.formFields = res.data.data.form_fields;
            console.log("formFields", this.formFields);
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : book-appointment/src/components/chat-live/chat-live.vue | Function : getFields() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    getQuestionFields(dep) {
      let data = {
        company_id: dep.company_id,
        department_id: dep.id,
      };
      this.$store
        .dispatch("GetQuestionFields", data)
        .then((res) => {
          if (res.data.data) {
            let multi = res.data.data.multi_form;
            this.multi_form = multi ? true : false;
            if (res.data.data.form_fields) {
              this.questionsFields = res.data.data.form_fields.filter(
                (qf) => qf.shown
              );
              console.log("question", this.questionsFields);
              this.questionsFields.forEach((el, index) => {
                el.form = false;
                if (el.type == "checkbox")
                  this.checkFields.push([index, el.required]);
                if (el.answer) {
                  const key = this.multi_form ? el.label : index;
                  if (el.type == "checkbox")
                    this.$set(
                      this.selectedInput,
                      `${key}`,
                      el.answer.split(",")
                    );
                  else this.$set(this.selectedInput, `${key}`, el.answer);
                }
              });
            }
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : book-appointment/src/components/chat-live/chat-live.vue | Function : getQuestionFields()",
            error
          );
          // Error response
          this.error = getErrorMessage(error, this);
          return false;
        });
    },

    getTimeZones() {
      this.success = "";
      this.error = "";
      this.show = true;
      this.$store
        .dispatch("GetTimeZone")
        .then((res) => {
          this.show = false;
          this.options = res.data.data;
          console.log("option", this.options);
          //   if (res.data.data != null) this.staffs = res.data.data;
        })
        .catch((error) => {
          this.$log.error(
            "File : book-appointment/src/components/chat-live/chat-live.vue | Function : getstaffs() | Error :",
            error
          );
          this.show = false;
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    // sendMessage (text) {
    //   console.log("sendMessage", text);
    //   if (text.length > 0) {
    //     this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
    //     // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } })
    //     this.onMessageWasSent(text)
    //   }
    // },
    // onMessageWasSent (message) {
    //   // called when the user sends a message
    //   // this.messageList = [ ...this.messageList, message ]
    //   this.messages = [ ...this.messages, message]
    // },

    async onMessageWasSent(message) {
      console.log(message);
      if (message.type == "text") {
        this.message = message.data.text;
      }
      if (message.type == "file") {
        this.message = message.data.text ? message.data.text : "";
      } else {
        this.message = this.message;
      }

      // if (!this.sendFile.prompt && !this.message.length && !file) return false;

      let chat = this.chatDetails.embed_data;
      console.log("Mesg & chat", this.message, chat);
      try {
        let formdata = new FormData();
        formdata.append("message", this.message);

        // // if (chat.is_contact) {
        // //   formdata.append("receiver_user_role", chat.user_role);
        // //   formdata.append("receiver_user_id", chat.id);
        // // } else {
        if (chat) {
          formdata.append("chat_head_id", chat.chat_head_id);
        } else {
          let chatHeadId = localStorage.getItem("chatHeadId");
          let userId = localStorage.getItem("userData");
          formdata.append("chat_head_id", chatHeadId);
        }

        // // }

        // if(this.sendFile.prompt)
        //   formdata.append("file", this.sendFile.file)

        if (message.data.file) formdata.append("file", message.data.file);

        if (this.replyMsg) formdata.append("reply_id", this.replyMsg.id);
        console.log("formdata", formdata);
        const res = await saveEventChatMessage(formdata);
        console.log("response", res);

        this.replyMsg = null;
        // this.message = "";

        // if (this.sendFile.prompt) {
        //   this.sendFile = {
        //     prompt: false,
        //     file: null,
        //     uploadProgress: 0
        //   };
        // }

        // if (res.data.status != "success") return;

        // if (chat.is_contact)
        //   this.$store.commit('SET_ACTIVE_CHAT', {chat_head_id: res.data.data.chat_head_id});
      } catch (error) {
        console.log(error);
        this.isDisabled = false;
      }
    },

    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isModalOpen = false;
      this.isChatOpen = true;
      this.ischatwindow = true;
      this.newMessagesCount = 0;
      this.getCustomStyle();
    },
    openModal() {
      this.$refs["live-chat-kickstart-form"].show();
      this.isModalOpen = true;
      this.newMessagesCount = 0;
      this.getCustomStyle();
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      console.log("Emit typing event");
    },
    editMessage(message) {
      const m = this.messageList.find((m) => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
    schedule: debounce(async function (form) {
      const isValidate = await this.$validator.validateAll(form);
      if (!isValidate) return;
      this.isScheduling = true;
      this.isLogin = false;
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;
      moment.locale("en");

      const scheduleEvent = { ...this.scheduleEvent };

      const fd = new FormData();
      fd.append("company_id", this.dataset.id);
      scheduleEvent.language = this.$i18n.locale;
      if (scheduleEvent.gender)
        scheduleEvent.gender = scheduleEvent.gender.toLowerCase();

      scheduleEvent.document =
        scheduleEvent.type != null && scheduleEvent.type != undefined
          ? scheduleEvent.type.code
          : null;

      scheduleEvent.document_path = null;
      if (this.images)
        scheduleEvent.document_path = this.images ? this.images : null;

      scheduleEvent.is_unio = 0;
      scheduleEvent.timezone = this.timeZone;
      scheduleEvent.is_booked_by_inmate = 0;
      console.log("scheduleEvent", scheduleEvent, isValidate);
      for (let key in scheduleEvent) {
        if (key == "dob") {
          if (scheduleEvent[key] && scheduleEvent[key].length == 10)
            fd.append(key, scheduleEvent[key]);
          else if (
            scheduleEvent[key] &&
            typeof scheduleEvent[key].toISOString == "function"
          )
            fd.append(key, scheduleEvent[key].toISOString());
          else fd.append(key, "");
        } else if (key == "profile_image") {
          fd.append(key, JSON.stringify(scheduleEvent[key] || ""));
        } else fd.append(key, scheduleEvent[key] || "");
      }
      var today = new Date();
      const time = moment(today).format("hh:mm A");
      let endT = new Date(
        today.getTime() + this.department.duration * 60 * 1000
      );
      const endTime = moment(endT, "HH:mm:ss").format("hh:mm A");

      this.currentSelectedDate = moment(today, "D/M/YYYY").format(
        "dddd, MMMM D, YYYY"
      );
      let appointment_details = {
        company_id: this.dataset.id,
        day: moment(this.currentSelectedDate, "dddd, MMMM D, YYYY").format(
          "dddd"
        ),
        date: moment(this.currentSelectedDate, "dddd, MMMM D, YYYY").format(
          "YYYY-MM-DD"
        ),
        start_time: time,
        end_time: endTime,
        department_id: this.dataset.live_chat_department_id,
        type: "walkin",
        is_rescheduled: "0",
        rescheduled_id: "",
        embed_live_chat: true,
      };

      fd.append(`appointment_details`, JSON.stringify(appointment_details));
      // this.show = false;
      if (this.questionsFields.length > 0) {
        this.questionsFields.forEach((qf, i) => {
          const fk = `question_option_field[${i}]`;
          fd.append(`${fk}[type]`, qf.type == "files" ? "file" : qf.type);
          fd.append(`${fk}[question]`, qf.label);

          let valueOption =
            this.selectedInput[qf.label] || this.selectedInput[i] || "";
          if (
            ["checkbox", "input", "text-area", "radio"].indexOf(qf.type) > -1
          ) {
            console.log("valueOption", valueOption);
            console.log("qf", qf);
            if (Array.isArray(valueOption)) valueOption = valueOption.join();
            else if (typeof valueOption != "string") valueOption = "";
            fd.append(`${fk}[answer]`, valueOption);
          } else if (qf.type == "files") {
            for (let docName in valueOption) {
              fd.append(
                `${fk}[answer][${docName}]`,
                valueOption[docName] || ""
              );
            }
          }
        });
      }

      const idocname = this.documentTypeArray.find(
        (dt) => dt.code == scheduleEvent.document
      );
      if (idocname && scheduleEvent.document_path) {
        const fk = `question_option_field[${this.questionsFields.length}]`;
        fd.append(`${fk}[type]`, "file");
        fd.append(`${fk}[question]`, "Identity Document");
        fd.append(
          `${fk}[answer][${idocname._label}]`,
          scheduleEvent.document_path
        );
      }

      // return false;
      console.log("scheduleEvent", scheduleEvent, appointment_details);
      try {
        const res = await this.$store.dispatch("ScheduleEvent", fd);
        this.isLogin = false;
        this.userdata = res.data.data;
        this.chatDetails = res.data;
        localStorage.setItem(
          "appointmentId",
          this.chatDetails.appointment_details.id
        );
        localStorage.setItem(
          "chatHeadId",
          this.chatDetails.embed_data.chat_head_id
        );
        localStorage.setItem(
          "departmentId",
          this.chatDetails.appointment_details.department_id
        );

        // let user={
        //   id: 'me',
        //   name: this.chatDetails.first_name,
        //   imageUrl: this.chatDetails.profile_image
        // }
        // this.participants.push(user)
        console.log(res);
        if (res.data.data && this.$store.state.auth.token != null) {
          this.$store.commit("SET_USER", {
            ...this.$store.state.auth.currentUser,
            ...res.data.data,
          });
        }

        if (res.data.appointment_details !== null) {
          this.appointmentDetails = res.data.appointment_details;
          if (this.type == "walkin") {
            this.startConf();
            return false;
          }
          if (this.appointmentDetails.is_premium) {
            this.isPremiumMeeting = true;
            this.appointmentDetails.currency =
              this.appointmentDetails.currency.toUpperCase();
            this.loadIntent();
          }
          let firstName = this.titleCase(res.data.staff_users.first_name);
          let lastName = this.titleCase(res.data.staff_users.last_name);
          let fullName = firstName + " " + lastName;
          let staff = {
            id:
              res.data.staff_users.first_name +
              " " +
              res.data.staff_users.last_name,
            name: fullName,
            imageUrl: res.data.staff_users.profile_image,
          };
          this.participants.push(staff);
          this.titleImageUrl = res.data.staff_users.profile_image;

          // else{
          //   this.isPremiumMeeting = false;
          // }
        }
        this.showConfirmation = true;
        this.show = false;
        window.location.hash = "appointment-request-sent";
        this.$refs["live-chat-kickstart-form"].hide();
        // Success response
        if (this.appointmentDetails.is_booked != true) {
          await this.autoLogin(res.data.encrypt_user_id);
          this.subcribeMessage(
            this.chatDetails.embed_data.chat_head_id,
            this.userdata.id
          );
          this.isModalOpen = false;
          this.isChatOpen = true;
          this.ischatwindow = true;
          this.newMessagesCount = 0;
          this.success = this.$t("EventScheduled");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
          this.getCustomStyle();
        }

        if (
          res.data.appointment_details.is_premium == 1 &&
          res.data.appointment_details.payment_status == 1
        ) {
          this.paymentDone = true;
        }
        //Reschedule Appointment
        if (
          this.isReschedule &&
          res.data.appointment_details.is_rescheduled == 1
        ) {
          this.paymentDone = true;

          var data = {
            appointment_id: res.data.appointment_details.id,
            is_missed_call: 0,
          };
          this.$store
            .dispatch("UpdateMissedCallFlag", data)
            .then((res) => {
              this.updateMissedCallFlag = false;
            })
            .catch((error) => {
              this.error = getErrorMessage(error, this);
              return false;
            });
        }
        Cookies.remove("appointment_id_reschedule");
      } catch (error) {
        this.$log.error(
          "File : book-appointment/src/components/chat-live/chat-live.vue | Function : schedule()",
          error
        );
        this.show = false;
        this.error =
          this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
            ? this.$t(error.replace(/[\s\/]/g, ""))
            : error;
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
        this.error = getErrorMessage(error, this);
      }
      this.isScheduling = false;
    }, 300),
    titleCase(string) {
      return string[0].toUpperCase() + string.slice(1).toLowerCase();
    },
    subcribeMessage(chat_head_id, userId) {
      console.log(chat_head_id, userId);
      window.Echo.private(`chat-user-${userId}`).listen(
        "ChatMessage",
        (response) => {
          const message = response.data;
          console.log(message);
          if (message.chat_head_id != chat_head_id) return;
          this.messages.push(message);
          this.getCustomStyle();
        }
      );
    },

    async autoLogin(id) {
      this.show = true;
      //       // this.$vs.loading();
      let data = {
        id: id,
      };
      try {
        const res = await this.$store.dispatch("AutoLogin", data);
        if (res) {
          this.activeUser = res.data;
          sessionStorage.setItem("activeUser", JSON.stringify(this.activeUser));
          console.log("autogin", this.activeUser);
          this.show = false;
          //this.$router.push("/" + this.cancelSlug).catch(() => {});
          //  this.$store.dispatch('staffOnlineIdsInit');

          this.getChatMessages(this.chatDetails.embed_data.chat_head_id);
          // this.success = this.$t("LoginSuccess");
          //   this.$toasted.show(this.success, {
          //     className: "top-alert",
          //     position: "top-center",
          //     type: "success",
          //     duration: 2000,
          // })
        }
      } catch (error) {
        this.$log.error(
          "File : book-appointment/src/components/chat-live/chat-live.vue | Function : AutoLogin()",
          error
        );
        this.error = getErrorMessage(error, this);
        this.show = false;
        this.errorMsg = true;
        return false;
      }
    },

    async getChatMessages(id) {
      this.searchMessageList = [];
      if (id == "" || id == null) return;
      let created_at = null;
      const data = {
        chat_head_id: id,
        limit: null,
        created_at,
      };
      console.log("req", data);
      const res = await getIndividualChatMessages(data);
      if (res.status == 200) {
        const locale = this.locale;
        let messagaeData = res.data.messages;
        const map1 = messagaeData.map((messageObject) => {
          if (
            messageObject &&
            messageObject.translations &&
            messageObject.translations.length > 0
          ) {
            const translated = messageObject.translations.find(
              (t) => t.locale == locale
            );
            if (translated) {
              messageObject.message = translated.message;
              return messageObject;
            }
            messageObject.message = messageObject.translations[0].message;
            return messageObject;
          }
          return messageObject;
        });
        console.log("map1", map1);
        this.messages = [...this.messages, ...map1];
      } else {
        console.log(res.statusText);
      }
      console.log("response", res);
      // try{
      //   const resp = await this.$store.dispatch(
      //   "GetIndividualChatMessages",
      //   data
      // );
      // console.log("chat Messages", resp);
      // this.searchMessageList = resp.data.messages.map(message => {
      //   message.message = this.getTextWithHighlights(message.message,searchString);
      //   return message;
      // });
      // }  catch(error){
      //   console.log(error)
      // }
    },
    getDepartmentDetails() {
      this.show = true;
      this.$store
        .dispatch("DepartmentDetails", this.dataset.live_chat_department_id)
        .then((res) => {
          this.show = false;
          this.slotMsg = false;
          if (res.data.status == "success") {
            this.department = res.data.data;
            this.company_id = this.department.company_id;
            this.getCustomStyle();
            console.log("department", this.department);
            if (this.department.company_profile_image) {
              this.profile_image = this.department.company_profile_image;
            }
            moment.locale("en");
            this.nextMonthStartDate = moment(new Date(), "MM/DD/YYYY")
              .add(1, "M")
              .startOf("month");
            this.department.disabled_dates.forEach((element) => {
              this.disabledDates.push(
                moment(element, "YYYY-MM-DD").format("YYYY-MM-DD")
              );
            });
            this.department.slots_availablity.forEach((element) => {
              this.getDatesByDay(moment(), element.day);
              this.getDatesByDay(this.nextMonthStartDate, element.day);
            });
            //custome time solts
            this.department.custom_slots_availablity.forEach((element) => {
              if (this.disabledDates.includes(element.day) == false) {
                this.dateMarked.push(
                  moment(element.day, "YYYY-MM-DD").format("D/M/YYYY")
                );
                this.slots_availablity.push({
                  date: moment(element.day, "YYYY-MM-DD").format("D/M/YYYY"),
                  class: "marked-class",
                });
              }
            });

            this.getDisabledDates();
            if (
              this.department.slots_availablity.length <= 0 &&
              this.department.custom_slots_availablity.length <= 0
            ) {
              this.slotMsg = true;
            }

            this.errorMsg = false;
            this.getFields(this.department.company_id);
            this.getQuestionFields(this.department);
            console.log("End>>>>>");
          } else {
            this.errorMsg = true;
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : book-appointment/src/components/chat-live/chat-live.vue | Function : getCompanyDetails() | Error :",
            error
          );
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },

    getDisabledDates() {
      console.log("Disabled");
      var startDate = moment();
      var endDate = moment(new Date(), "MM/DD/YYYY").add(1, "M").endOf("month");
      endDate = endDate.format("YYYY-MM-DD");
      while (startDate.isSameOrBefore(endDate, "day")) {
        if (this.dateMarked.includes(startDate.format("D/M/YYYY")) == false) {
          this.disabledDates.push(startDate.format("D/M/YYYY"));
        }
        startDate.add(1, "days");
      }
    },

    getDatesByDay(date, day) {
      var monday = moment(date).startOf("month").day(day);
      if (monday.date() > 7) monday.add(7, "d");
      var month = monday.month();
      let light = "marked-class";
      let dark = "vfc-marked vfc-hover vfc-borderd";
      let slotDate = monday.format("DD-MM-YYYY");
      let check = slotDate == this.currentDate ? dark : light;
      while (month === monday.month()) {
        // if time slot available
        if (this.disabledDates.includes(monday.format("YYYY-MM-DD")) == false) {
          if (moment().diff(monday.format("YYYY-MM-DD")) <= 0) {
            this.dateMarked.push(monday.format("D/M/YYYY"));

            this.slots_availablity.push({
              date: monday.format("D/M/YYYY"),
              class: check,
            });

            // return;
          } else if (
            moment(date, "YYYY-MM-DD").format("YYYY-MM-DD") ==
            monday.format("YYYY-MM-DD")
          ) {
            this.dateMarked.push(monday.format("D/M/YYYY"));
            this.slots_availablity.push({
              date: monday.format("D/M/YYYY"),
              class: check,
            });
          }
        }
        monday.add(7, "d");
      }
    },

    getForm() {
      this.showForm = true;
    },

    getCustomStyle() {
      let data;
      if (this.companyDetails) {
        data = {
          company_id: this.dataset.id,
        };
      } else {
        data = {
          company_id: this.dataset.id,
          department_id: this.id,
        };
      }
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          console.log(res.data);

          $(".sc-launcher").css({
            "background-color": res.data.data.button_background_color,
          });
          $(".sc-header").css({
            "background-color": res.data.data.form_background_color,
          });
          $(".modal-header").css({
            "background-color": res.data.data.form_background_color,
          });
          $("messageList").css({
            "background-color": res.data.data.form_background_color,
          });
          $(".modal-title").css({ color: res.data.data.form_text_color });
          $(".close").css({
            color: res.data.data.form_text_color,
            "background-color": res.data.data.form_background_color,
          });
          $(".sc-header--title").css({ color: res.data.data.form_text_color });
          $(".sc-message--text-content").css({
            color: res.data.data.form_text_color,
          });
          $(".sc-message--file-text").css({
            color: res.data.data.form_text_color,
          });
          $(".sc-header--close-button").css({
            "background-color": res.data.data.button_background_color,
          });

          $(".sc-message--text").css({
            color: res.data.data.form_text_color,
          });

          $(".sent").find(".sc-message--text").removeAttr("style");
          $(".sent").find(".sc-message--text").css({
            "background-color": res.data.data.button_background_color,
            color: res.data.data.form_text_color,
          });

          $(".sent").find(".sc-message--file").removeAttr("style");
          $(".sent").find(".sc-message--file").css({
            "background-color": "",
          });

          $(".sent").find(".sc-message--file-name").removeAttr("style");
          $(".sent").find(".sc-message--file-name").css({
            // "background-color": res.data.data.button_background_color,
            color: res.data.data.form_text_color,
          });

          $(".sent").find(".sc-message--file-text").removeAttr("style");
          $(".sent").find(".sc-message--file-text").css({
            "background-color": res.data.data.button_background_color,
            color: res.data.data.form_text_color,
          });

          $(
            "span.vfc-span-day.vfc-disabled.vfc-cursor-not-allowed.vfc-hover, .vfc-day, .vfc-top-date.vfc-center span, span.e-input-group-icon.e-ddl-icon.e-search-icon"
          ).css({ color: res.data.data.form_text_color });
          $(".vfc-arrow-right, .vfc-arrow-left").css({
            "border-color": res.data.data.form_text_color,
          });

          $(".custome-text-color").css({
            color: res.data.data.form_text_color,
          });
          let css = {
            color: this.textColor.color,
            "border-bottom-color": this.textColor.color,
          };
          $(".e-control-wrapper").css(css);
          $("span.e-input-group-icon.e-ddl-icon.e-search-icon").css(
            this.textColor
          );
          this.textColor = {
            color: res.data.data.form_text_color + " !important",
          };

          // this.font_size = {
          //   title: res.data.data.title_font_size,
          //   paragraph: res.data.data.paragraph_font_size
          // }

          // $(".the-footer p, .the-footer a").css({
          //   color: res.data.data.form_text_color,
          // });

          this.buttonCss = {
            "background-color":
              res.data.data.button_background_color + "!important",
            "border-color":
              res.data.data.button_background_color + "!important",
            color: res.data.data.button_text_color,
          };

          const rootCSSVars = document.querySelector(":root");
          rootCSSVars.style.setProperty(
            "--booking-form-button-bg",
            res.data.data.button_background_color
          );
        })
        .catch((error) => {
          this.$log.error(
            "File : book-appointment/src/components/chat-live/chat-live.vue | Function : getCustomStyle() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    async getAppointmentDetails() {
      // let userId=localStorage.getItem("userData");
      let appointmentId = localStorage.getItem("appointmentId");
      let chatHeadId = localStorage.getItem("chatHeadId");
      let userId = this.$store.getters.currentUser.id;
      let depID = localStorage.getItem("departmentId");
      console.log("hii", chatHeadId, userId, depID);

      console.log("respo", appointmentId);
      if (this.dataset.live_chat_department_id != depID) {
        this.isModalOpen = true;
        this.meet = false;
        this.ischatwindow = false;
        return;
      }

      const data = {
        id: appointmentId,
      };
      const res = await getAppointmentDetails(data);
      console.log("respo", res);
      let appointDetails = res.data;
      if (res.status == 200) {
        let mins_left = res.data.data.mins_left;
        let duration = res.data.data.department.duration;
        let time = mins_left + duration;
        console.log(time);
        if (time > 0) {
          console.log("meeting going on");
          this.meet = true;
          this.ischatwindow = true;
          this.getCustomStyle();
          let data = {
            ignore: ["contacts"],
          };
          let participantData = await getChatAndContact(data);
          console.log(participantData);
          let getChatDetails = participantData.data.chats;
          let getDetails = getChatDetails.find(
            (element) => element.id == chatHeadId
          );
          console.log(getDetails);
          let participantName = this.titleCase(getDetails.display_name);
          let staff = {
            id: getDetails.display_name,
            name: participantName,
            imageUrl: getDetails.participants[1].profile_picture,
          };
          this.participants.push(staff);
          this.titleImageUrl = getDetails.participants[1].profile_picture;
          this.getChatMessages(chatHeadId);
          this.subcribeMessage(chatHeadId, userId);
        } else {
          console.log("meeting end");
          this.meet = false;
          localStorage.removeItem("appointmentId");
          localStorage.removeItem("chatHeadId");
          localStorage.removeItem("departmentId");
        }
      }
      // let appointmentDetails=res.data.data;
      // // const m = appointmentDetails.find(m=>m.id === appointmentId);
      // console.log('userData',userId, m);
    },
    /**
     * validate phone number
     */
    onInput({ number, isValid, country }) {
      this.scheduleEvent.contact_number = number["international"];
    },
    /**
     * append country code
     */
    appendCode() {
      if (this.scheduleEvent.contact_number.includes("+") == false) {
        this.scheduleEvent.contact_number =
          this.country + " " + this.scheduleEvent.contact_number;
      }
    },
    /* Country Code
     */
    countryChanged(country) {
      this.country = "+" + country.dialCode;
    },
  },
};
</script>
<style>
.modal-content {
  width: 370px;
  top: 30px;
  height: calc(100% - 120px);
  max-height: 590px;
  box-sizing: border-box;
  box-shadow: 0 7px 40px 2px rgba(148, 149, 150, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 10px;
  border: 0px !important;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
}

.modal-dialog {
  position: fixed;
  right: 25px;
  bottom: 0;
}

.modal-header {
  color: rgb(255, 255, 255);
  min-height: 75px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  padding: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  position: relative;
  box-sizing: border-box;
  display: flex;
}
.modal-header .close {
  border: none;
  padding: 13px;
  color: rgb(255, 255, 255);
}

.modal-title {
  color: white;
}
.modal-body {
  background-color: rgb(255, 255, 255);
}
.activeChat {
  position: relative;
  z-index: -1;
}
.custom-control-label {
  margin-left: 6px;
}
.live-chat .department-list {
  text-align: center;
}
.live-chat .department-header {
  margin-top: 20px;
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 20px;
  text-align: center;
}
.live-chat .department-header .department-name {
  text-align: center;
}
.live-chat .department-header .department-name span {
  text-align: center;
  font-size: 30px;
}
.live-chat .department-desc {
  color: var(--text-color-level2, rgba(77, 80, 85, 0.6));
  font-size: 14px;
  display: flex;
  align-items: center;
}
.nextArrow {
  text-align: end;
}
.sc-chat-window[data-v-b0ecfbf8] {
    z-index: 600 !important;
}
 .sc-launcher[data-v-19cbdabe] {
    z-index:600 !important;
  }
@media only screen and (max-width: 450px) {
  .sc-chat-window[data-v-b0ecfbf8] {
    width: 98%;
    height: 100%;
    max-height: 77%;
    right: 0;
    bottom: 90px;
    border-radius: 15px;
    transition: 0.1s ease-in-out;
    z-index: 250;
  }
  .sc-header[data-v-44306e78] {
    border-radius: 19px;
  }
  .modal-content {
    box-shadow: 0 7px 40px 2px rgba(148, 149, 150, 0.1);
    background: #fff;
    border-radius: 15px;
    border: 0px !important;
    width: 360px;
    max-height: 80% !important;
    position: relative;
    left: 6%;
    top: 7%;
  }
}
.sc-header--img {
  border-radius: 30%;
  align-self: center;
  padding: 10px;
  width: 46px !important;
}
.sc-image[data-v-823c12b8] {
  max-width: 50% !important;
  min-width: 0% !important;
}
.sc-message--toolbox .sc-message--text-content span {
  color: #484848;
}
.sc-message--file-name {
  margin-top: 18px !important;
  font-size: 15px !important;
}
.sc-message--file-name a {
  color: black !important;
}
.sc-message--file-text {
  text-align: center !important;
  margin-left: 100px !important;
}
.sc-message--text-content {
  margin-top: 5px !important;
  margin-bottom: 7px !important;
}
</style>
